import layout from '@/layout/index.vue'
import { useMerchantStore } from '@/stores/modules/merchant'

export default {
  name: 'group-spm-customer-prepayment-qrcode-pay',
  meta: { title: '我的收款', icon: 'icon-order' },

  children: [
    {
      name: 'spm-customer-prepayment-qrcode-pay',
      meta: {
        title: '我的收款',
        icon: 'el-icon-wallet',
        isHiddenRoute: () => {
          const merchantStore = useMerchantStore()
          // 如果未开启顾客预收款，则隐藏路由
          return !merchantStore.merchantInfo || !merchantStore.merchantInfo.is_enable_customer_prepayment_qrcode
        }
      },

      routers: [
        {
          path: '/customer-prepayment-qrcode-pay',
          name: 'customer-prepayment-qrcode-pay',
          component: layout,
          meta: { title: '我的收款' },
          children: [
            {
              path: 'my-today-record',
              name: 'my-today-record',
              component: () => import('@/views/customer-prepayment-qrcode-pay/my-today-record.vue'),
              meta: {
                title: '我的收款',
                vPermission: [
                  'pc-bar-customer-prepayment-qrcode-pay:customer-prepayment-qrcode-pay:my-today-record'
                ]
              }
            }
          ]
        }
      ]
    }
  ]
}
